import { pick } from '../pick';

const normalizeProcurementClauseDetail = raw => {
  if (!raw || typeof raw !== 'object') return null;

  return {
    id: pick(raw, 'id', 'Id'),
    procurementId: pick(raw, 'procurementId', 'ProcurementId'),
    clauseDetailId: pick(raw, 'clauseDetailId', 'ClauseDetailId'),
    clauseTitle: pick(raw, 'clauseTitle', 'ClauseTitle'),
    ordreNumber: pick(raw, 'ordreNumber', 'OrdreNumber') ?? 0,
    isShow: pick(raw, 'isShow', 'IsShow') ?? false,
    isActive: pick(raw, 'isActive', 'IsActive'),
    clauseDescription: pick(raw, 'clauseDescription', 'ClauseDescription'),
    isShowToDMUT: pick(raw, 'isShowToDMUT', 'IsShowToDMUT') ?? false,
  };
};

const normalizeProcurementClauseDetails = raw => {
  const items =
    raw?.procurementClauseDetails ?? raw?.ProcurementClauseDetails ?? [];

  if (!Array.isArray(items)) return [];

  return items.map(normalizeProcurementClauseDetail).filter(Boolean);
};
const normalizeProductType = productTypeRaw => {
  if (!productTypeRaw) return null;
  const productRaw = productTypeRaw.product ?? productTypeRaw.Product;

  return {
    id: pick(productTypeRaw, 'id', 'Id'),
    name: pick(productTypeRaw, 'name', 'Name'),
    description: pick(productTypeRaw, 'description', 'Description'),
    product: productRaw
      ? {
          id: pick(productRaw, 'id', 'Id'),
          name: pick(productRaw, 'name', 'Name'),
        }
      : null,
  };
};

const normalizeNamedEntity = raw => {
  if (raw === null || raw === undefined || raw === '') return null;
  if (typeof raw !== 'object') {
    const text = String(raw).trim();
    if (!text) return null;
    return {
      id: null,
      name: text,
      description: null,
      currencyName: null,
      currencyCode: null,
    };
  }
  return {
    id: pick(raw, 'id', 'Id'),
    name:
      pick(raw, 'name', 'Name') ??
      pick(raw, 'description', 'Description') ??
      null,
    description: pick(raw, 'description', 'Description'),
    currencyName: pick(raw, 'currencyName', 'CurrencyName'),
    currencyCode: pick(raw, 'currencyCode', 'CurrencyCode'),
  };
};

const normalizePortRestrictions = raw => {
  const list = raw?.portRestriction ?? raw?.PortRestriction ?? [];
  if (!Array.isArray(list)) return [];

  return list.map(item => ({
    id: pick(item, 'id', 'Id'),
    locationId:
      pick(item, 'locationId', 'LocationId') ??
      pick(item, 'incotermLocationId', 'IncotermLocationId'),
    locationName:
      pick(item, 'locationName', 'LocationName') ??
      pick(item, 'incotermLocationName', 'IncotermLocationName') ??
      pick(item, 'name', 'Name'),
    incotermLocationId:
      pick(item, 'incotermLocationId', 'IncotermLocationId') ??
      pick(item, 'locationId', 'LocationId'),
    incotermLocationName:
      pick(item, 'incotermLocationName', 'IncotermLocationName') ??
      pick(item, 'locationName', 'LocationName'),
    name: pick(item, 'name', 'Name'),
    portName:
      pick(item, 'portName', 'PortName') ??
      pick(item, 'name', 'Name') ??
      pick(item, 'locationName', 'LocationName') ??
      pick(item, 'incotermLocationName', 'IncotermLocationName'),
    draftMin: pick(item, 'draftMin', 'DraftMin'),
    draftMax: pick(item, 'draftMax', 'DraftMax'),
    loaMin: pick(item, 'loaMin', 'LoaMin'),
    loaMax: pick(item, 'loaMax', 'LoaMax'),
    dwtMin: pick(item, 'dwtMin', 'DwtMin'),
    dwtMax: pick(item, 'dwtMax', 'DwtMax'),
    detailUrl:
      pick(item, 'detailUrl', 'DetailUrl') ??
      pick(item, 'link', 'Link') ??
      pick(item, 'url', 'Url'),
  }));
};
const normalizeCounterPaymentTermItem = raw => {
  if (!raw || typeof raw !== 'object') return null;
  return {
    id: pick(raw, 'id', 'Id'),
    procurementId: pick(raw, 'procurementId', 'ProcurementId'),
    procurementMitraId: pick(raw, 'procurementMitraId', 'ProcurementMitraId'),
    invoicingQuantityId: pick(
      raw,
      'invoicingQuantityId',
      'InvoicingQuantityId'
    ),
    invoicingQuantity: normalizeNamedEntity(
      raw.invoicingQuantity ?? raw.InvoicingQuantity
    ),
    modeInvoicingQuantityId: pick(
      raw,
      'modeInvoicingQuantityId',
      'ModeInvoicingQuantityId'
    ),
    modeInvoicingQuantity: normalizeNamedEntity(
      raw.modeInvoicingQuantity ?? raw.ModeInvoicingQuantity
    ),
    paymentCurrencyId: pick(raw, 'paymentCurrencyId', 'PaymentCurrencyId'),
    paymentCurrency: normalizeNamedEntity(
      raw.paymentCurrency ?? raw.PaymentCurrency
    ),
    descriptionOfPaymentTerms: pick(
      raw,
      'descriptionOfPaymentTerms',
      'DescriptionOfPaymentTerms'
    ),
    createdDate: pick(raw, 'createdDate', 'CreatedDate'),
    updatedDate: pick(raw, 'updatedDate', 'UpdatedDate'),
  };
};

const normalizeCounterDelayPenaltyTermItem = raw => {
  if (!raw || typeof raw !== 'object') return null;
  return {
    id: pick(raw, 'id', 'Id'),
    procurementId:
      pick(raw, 'procurementId', 'ProcurementId') ??
      pick(raw, 'procurementFK', 'ProcurementFK'),
    procurementMitraId: pick(raw, 'procurementMitraId', 'ProcurementMitraId'),
    delayPenaltyAmount: pick(raw, 'delayPenaltyAmount', 'DelayPenaltyAmount'),
    descriptionOfDelayPenaltyTerms: pick(
      raw,
      'descriptionOfDelayPenaltyTerms',
      'DescriptionOfDelayPenaltyTerms'
    ),
    createdDate: pick(raw, 'createdDate', 'CreatedDate'),
    updatedDate: pick(raw, 'updatedDate', 'UpdatedDate'),
  };
};

const normalizeCounterComplianceItem = raw => {
  if (!raw || typeof raw !== 'object') return null;
  return {
    id: pick(raw, 'id', 'Id'),
    procurementId: pick(raw, 'procurementId', 'ProcurementId'),
    procurementMitraId: pick(raw, 'procurementMitraId', 'ProcurementMitraId'),
    lawId: pick(raw, 'lawId', 'LawId'),
    law: normalizeNamedEntity(raw.law ?? raw.Law),
    arbitrationId: pick(raw, 'arbitrationId', 'ArbitrationId'),
    arbitration: normalizeNamedEntity(raw.arbitration ?? raw.Arbitration),
    otherTermsAndCondition: pick(
      raw,
      'otherTermsAndCondition',
      'OtherTermsAndCondition'
    ),
    additionalNotes: pick(raw, 'additionalNotes', 'AdditionalNotes'),
    createdDate: pick(raw, 'createdDate', 'CreatedDate'),
    updatedDate: pick(raw, 'updatedDate', 'UpdatedDate'),
  };
};

const normalizeCounterList = (raw, camelKey, pascalKey, normalizeItem) => {
  const list = raw?.[camelKey] ?? raw?.[pascalKey] ?? [];
  if (!Array.isArray(list)) return [];
  return list.map(normalizeItem).filter(Boolean);
};

export const normalizeProcurementDetail = raw => {
  if (!raw || typeof raw !== 'object') return null;

  const productTypeRaw = raw.productType ?? raw.ProductType;

  return {
    id: pick(raw, 'id', 'Id'),
    procurementNumber: pick(raw, 'procurementNumber', 'ProcurementNumber'),
    titleProcurement: pick(raw, 'titleProcurement', 'TitleProcurement'),
    description: pick(raw, 'description', 'Description'),
    procurementType: pick(raw, 'procurementType', 'ProcurementType'),
    procurementTypeHeaderLabel: pick(
      raw,
      'procurementTypeHeaderLabel',
      'ProcurementTypeHeaderLabel'
    ),
    contractType: pick(raw, 'contractType', 'ContractType'),
    contractPeriodSpot: pick(raw, 'contractPeriodSpot', 'ContractPeriodSpot'),
    contractPeriodTermStart: pick(
      raw,
      'contractPeriodTermStart',
      'ContractPeriodTermStart'
    ),
    contractPeriodTermEnd: pick(
      raw,
      'contractPeriodTermEnd',
      'ContractPeriodTermEnd'
    ),
    productType: normalizeProductType(productTypeRaw),
    procurementProductTypes:
      raw.procurementProductTypes ?? raw.ProcurementProductTypes ?? [],
    operationalTolerance: pick(
      raw,
      'operationalTolerance',
      'OperationalTolerance'
    ),
    partyType: pick(raw, 'partyType', 'PartyType'),
    productSpecification: pick(
      raw,
      'productSpecification',
      'ProductSpecification'
    ),
    notesForQuantityAndDeliveryTerms: pick(
      raw,
      'notesForQuantityAndDeliveryTerms',
      'NotesForQuantityAndDeliveryTerms'
    ),
    quantityDiscrepancy: pick(
      raw,
      'quantityDiscrepancy',
      'QuantityDiscrepancy'
    ),
    delayPenaltyTerms: pick(raw, 'delayPenaltyTerms', 'DelayPenaltyTerms'),
    delivery: pick(raw, 'delivery', 'Delivery'),
    nominationProcedure: pick(
      raw,
      'nominationProcedure',
      'NominationProcedure'
    ),
    firstTimeSupply: pick(raw, 'firstTimeSupply', 'FirstTimeSupply'),
    redChannelPolicy: pick(raw, 'redChannelPolicy', 'RedChannelPolicy'),
    deliveryCustom: pick(raw, 'deliveryCustom', 'DeliveryCustom'),
    otherTermsAndCondition: pick(
      raw,
      'otherTermsAndCondition',
      'OtherTermsAndCondition'
    ),
    additionalNotes: pick(raw, 'additionalNotes', 'AdditionalNotes'),
    isQuantityDiscrepancyMandatory: pick(
      raw,
      'isQuantityDiscrepancyMandatory',
      'IsQuantityDiscrepancyMandatory'
    ),
    isDelayPenaltyTermsMandatory: pick(
      raw,
      'isDelayPenaltyTermsMandatory',
      'IsDelayPenaltyTermsMandatory'
    ),
    isDeliveryMandatory: pick(
      raw,
      'isDeliveryMandatory',
      'IsDeliveryMandatory'
    ),
    isNominationProcedureMandatory: pick(
      raw,
      'isNominationProcedureMandatory',
      'IsNominationProcedureMandatory'
    ),
    isFirstTimeSupplyMandatory: pick(
      raw,
      'isFirstTimeSupplyMandatory',
      'IsFirstTimeSupplyMandatory'
    ),
    isRedChannelPolicyMandatory: pick(
      raw,
      'isRedChannelPolicyMandatory',
      'IsRedChannelPolicyMandatory'
    ),
    isDeliveryCustomMandatory: pick(
      raw,
      'isDeliveryCustomMandatory',
      'IsDeliveryCustomMandatory'
    ),
    submittedDateTenderOpening: pick(
      raw,
      'submittedDateTenderOpening',
      'SubmittedDateTenderOpening'
    ),
    tenderOpeningStatus: pick(
      raw,
      'tenderOpeningStatus',
      'TenderOpeningStatus'
    ),
    isRequestHpsCompleted:
      pick(raw, 'isRequestHpsCompleted', 'IsRequestHpsCompleted') ??
      pick(raw, 'isHPSRequestCompleted', 'IsHPSRequestCompleted'),
    isInvitePanitiaTenderCompleted: pick(
      raw,
      'isInvitePanitiaTenderCompleted',
      'IsInvitePanitiaTenderCompleted'
    ),
    isReqFreightAvailabilityEnable: pick(
      raw,
      'isReqFreightAvailabilityEnable',
      'IsReqFreightAvailabilityEnable'
    ),
    freightRequestNumber: pick(
      raw,
      'freightRequestNumber',
      'FreightRequestNumber'
    ),
    freightRequestDate: pick(raw, 'freightRequestDate', 'FreightRequestDate'),
    freightCostStatus: pick(raw, 'freightCostStatus', 'FreightCostStatus'),
    statusHPS2:
      pick(raw, 'statusHPS2', 'StatusHPS2') ??
      pick(raw, 'statusHps', 'StatusHps'),
    hpsRequestNumber: pick(raw, 'hpsRequestNumber', 'HPSRequestNumber'),
    hpsRequestDate: pick(raw, 'hpsRequestDate', 'HPSRequestDate'),
    titleNotaDinas: pick(raw, 'titleNotaDinas', 'TitleNotaDinas'),
    noNotaDinas: pick(raw, 'noNotaDinas', 'NoNotaDinas'),
    documentNotaDinas: pick(raw, 'documentNotaDinas', 'DocumentNotaDinas'),
    documentNotaDinasName: pick(
      raw,
      'documentNotaDinasName',
      'DocumentNotaDinasName'
    ),
    documentNotaDinasUrl: pick(
      raw,
      'documentNotaDinasUrl',
      'DocumentNotaDinasUrl'
    ),
    documentNotaDinasRilis: pick(
      raw,
      'documentNotaDinasRilis',
      'DocumentNotaDinasRilis'
    ),
    documentNotaDinasRilisUrl: pick(
      raw,
      'documentNotaDinasRilisUrl',
      'DocumentNotaDinasRilisUrl'
    ),
    evaluationStatus: pick(raw, 'evaluationStatus', 'EvaluationStatus'),
    evaluationStatusWording: pick(
      raw,
      'evaluationStatusWording',
      'EvaluationStatusWording'
    ),
    statusHps: pick(raw, 'statusHps', 'StatusHps'),
    invoicingQuantityId: pick(
      raw,
      'invoicingQuantityId',
      'InvoicingQuantityId'
    ),
    invoicingQuantity: normalizeNamedEntity(
      raw.invoicingQuantity ?? raw.InvoicingQuantity
    ),
    modeInvoicingQuantityId: pick(
      raw,
      'modeInvoicingQuantityId',
      'ModeInvoicingQuantityId'
    ),
    modeInvoicingQuantity: normalizeNamedEntity(
      raw.modeInvoicingQuantity ?? raw.ModeInvoicingQuantity
    ),
    paymentCurrencyId: pick(raw, 'paymentCurrencyId', 'PaymentCurrencyId'),
    paymentCurrency: normalizeNamedEntity(
      raw.paymentCurrency ?? raw.PaymentCurrency
    ),
    descriptionOfPaymentTerms: pick(
      raw,
      'descriptionOfPaymentTerms',
      'DescriptionOfPaymentTerms'
    ),
    delayPenaltyAmount: pick(raw, 'delayPenaltyAmount', 'DelayPenaltyAmount'),
    descriptionOfDelayPenaltyTerms: pick(
      raw,
      'descriptionOfDelayPenaltyTerms',
      'DescriptionOfDelayPenaltyTerms'
    ),
    lawId: pick(raw, 'lawId', 'LawId'),
    law: normalizeNamedEntity(raw.law ?? raw.Law),
    arbitrationId: pick(raw, 'arbitrationId', 'ArbitrationId'),
    arbitration: normalizeNamedEntity(raw.arbitration ?? raw.Arbitration),
    portRestriction: normalizePortRestrictions(raw),
    proposalSubmissionDeadline: pick(
      raw,
      'proposalSubmissionDeadline',
      'ProposalSubmissionDeadline'
    ),
    proposalValidityPeriodMax: pick(
      raw,
      'proposalValidityPeriodMax',
      'ProposalValidityPeriodMax'
    ),
    operationalToleranceCounter: pick(
      raw,
      'operationalToleranceCounter',
      'OperationalToleranceCounter'
    ),
    operationalToleranceOptionsCounter: pick(
      raw,
      'operationalToleranceOptionsCounter',
      'OperationalToleranceOptionsCounter'
    ),
    operationalToleranceOptionsCounterLabel: pick(
      raw,
      'operationalToleranceOptionsCounterLabel',
      'OperationalToleranceOptionsCounterLabel'
    ),
    proposalValidityPeriodMaxCounter: pick(
      raw,
      'proposalValidityPeriodMaxCounter',
      'ProposalValidityPeriodMaxCounter'
    ),
    globalNotes: pick(raw, 'globalNotes', 'GlobalNotes'),
    counterPaymentTerm: normalizeCounterList(
      raw,
      'counterPaymentTerm',
      'CounterPaymentTerm',
      normalizeCounterPaymentTermItem
    ),
    counterDelayPenaltyTerm: normalizeCounterList(
      raw,
      'counterDelayPenaltyTerm',
      'CounterDelayPenaltyTerm',
      normalizeCounterDelayPenaltyTermItem
    ),
    counterCompliance: normalizeCounterList(
      raw,
      'counterCompliance',
      'CounterCompliance',
      normalizeCounterComplianceItem
    ),
    invitationEventDate: pick(
      raw,
      'invitationEventDate',
      'InvitationEventDate'
    ),
    invitationStartTime: pick(
      raw,
      'invitationStartTime',
      'InvitationStartTime'
    ),
    invitationEndTime: pick(raw, 'invitationEndTime', 'InvitationEndTime'),
    invitationLocation: pick(raw, 'invitationLocation', 'InvitationLocation'),
    invitationAgenda: pick(raw, 'invitationAgenda', 'InvitationAgenda'),
    dataProcurmentLain: pick(raw, 'dataProcurmentLain', 'DataProcurmentLain'),
    procurementClauseDetails: normalizeProcurementClauseDetails(raw),
    procurementMitra: normalizeProcurementMitraList(
      raw.procurementMitra ?? raw.ProcurementMitra
    ),
    gtcs: pick(raw, 'gtcs', 'Gtcs') ?? [],
  };
};

const normalizeProcurementMitraItem = raw => {
  if (!raw || typeof raw !== 'object') return null;
  return {
    id: pick(raw, 'id', 'Id'),
    companyMitraId: pick(raw, 'companyMitraId', 'CompanyMitraId'),
    companyName: pick(raw, 'companyName', 'CompanyName'),
    statusInvitation: pick(raw, 'statusInvitation', 'StatusInvitation'),
    isDeleted: pick(raw, 'isDeleted', 'IsDeleted') ?? false,
    idOffer: pick(raw, 'idOffer', 'IdOffer'),
  };
};

const normalizeProcurementMitraList = raw => {
  if (!Array.isArray(raw)) return [];
  return raw.map(normalizeProcurementMitraItem).filter(Boolean);
};

export const unwrapProcurement = response => {
  if (!response) return null;

  const isApiWrapper =
    response.data &&
    response.procurementNumber === undefined &&
    response.ProcurementNumber === undefined &&
    response.titleProcurement === undefined &&
    response.TitleProcurement === undefined;

  const raw = isApiWrapper ? response.data : response;
  return normalizeProcurementDetail(raw);
};
